import "core-js/modules/es6.function.name";
import { createDirective as createCompatableDirective } from '@tencent/vue-compat/lib/directive';
import { bindMiddlewares } from "../middleware";
import { parseVueBindingValue } from "../util";
/**
 * 创建指令
 * @param {VueInstance} Vue Vue实例
 * @param {Promise<any>} reportPromise 异步Promise
 * @param {DirectiveOptions} options 指令配置
 * @param {String} options.name 指令名称，默认为v-report
 * @returns {Record<string, VueDirectiveHook>}
 */

export function createDirective(Vue) {
  var reportPromise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Promise.resolve();
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    name: 'report'
  };

  function handleDirective(el, binding, event) {
    reportPromise.then(function () {
      bindMiddlewares(el, parseVueBindingValue(binding, event));
    });
  }

  var directives = createCompatableDirective({
    /**
     * @type {VftReport.DirectiveFunction}
     */
    bind: function bind(el, binding) {
      handleDirective(el, binding, 'bind');
    },

    /**
     * @type {VftReport.DirectiveFunction}
     */
    update: function update(el, binding) {
      handleDirective(el, binding, 'update');
    },

    /**
     * @type {VftReport.DirectiveFunction}
     */
    unbind: function unbind(el, binding) {
      handleDirective(el, binding, 'unbind');
    }
  }, Vue);
  var _options$name = options.name,
      name = _options$name === void 0 ? 'report' : _options$name;
  Vue.directive(name, directives);
  return directives;
}